import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Notification from "../../elements/notification/Notification";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import PageSpinner from "../../elements/spinner/PageSpinner";
import { Alert } from "@material-ui/lab";
import { useHistory } from "react-router-dom";
import GoToBackButton from "../../elements/goToBack/GoToBack";
import { TextField } from "@material-ui/core";
import BaseRatesEditForm from "./BaseRatesEditForm";
import { useTranslation } from "react-i18next";

import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledBlockLabel, StyledFormBlock, StyledFormGrid, StyledInputBlock } from "../../styles/styledTabsForm";
import { StyledFeeDetailsWrapper } from "../../fee/styledFee";

const BaseRatesDetailsContainer = ({ match }) => {
  const { t } = useTranslation("baseRatesPage");
  const [rate, setRate] = useState();
  const history = useHistory();

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchRate = () => {
    axios.get("/api/rate-bases/" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setRate(response.data);
      }
    }).catch(error => {
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  };
  useEffect(() => {
    fetchRate();
  }, []);

  if (!rate) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (rate.length === 0) {
    return <Alert severity="warning">{t("details.changeForm.emptyData")}</Alert>;
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{t("details.meta.title")} {rate.currency.asset} • eXsoft.io</title>
        </Helmet>
        <StyledFeeDetailsWrapper>
          <GoToBackButton
            handler={() => {history.goBack();}}
            pt="20"
            pb="30"
          />
          <StyledFormGrid>
            <StyledFormBlock>
              <StyledBlockLabel>
                {t("details.changeForm.rate")}
              </StyledBlockLabel>
              <StyledInputBlock>
                <TextField
                  className="grid-form__input"
                  label={t("details.changeForm.currency")}
                  type="text"
                  value={rate.currency.asset}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("details.changeForm.rateSelling")}
                  type="text"
                  value={rate.rateSelling}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("details.changeForm.ratePurchase")}
                  type="text"
                  value={rate.ratePurchase}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("details.changeForm.selling")}
                  type="text"
                  value={rate.selling}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("details.changeForm.purchase")}
                  type="text"
                  value={rate.purchase}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
              </StyledInputBlock>
              <div className="clear-column" />
            </StyledFormBlock>
            <StyledFormBlock>
              <StyledBlockLabel>
                {t("details.changeForm.adjustment")}
              </StyledBlockLabel>
              <BaseRatesEditForm
                rate={rate}
                fetchRate={fetchRate}
                notification={notification}
                setNotification={setNotification}
                url="/api/base-rates/"
              />
              <div className="clear-column" />
            </StyledFormBlock>
          </StyledFormGrid>
        </StyledFeeDetailsWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default BaseRatesDetailsContainer;